import React from "react";
import MainPagetitle from "../../layouts/MainPagetitle";

const AppPageTableLayout = ({
    pageTitle,
    mainTitle,
    parentTitle,
    pageIcon,
    tableTitle,
    rightSideComponent,
    children,
}) => {
    return (
        <>
            <MainPagetitle
                pageTitle={pageTitle}
                mainTitle={mainTitle}
                parentTitle={parentTitle || "Home"}
                pageIcon={pageIcon}
            />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                {/* Table Header Section */}
                                <div className="tbl-caption-container justify-content-between">
                                    {tableTitle && <h4 className="heading mb-0">{tableTitle}</h4>}
                                    {rightSideComponent && rightSideComponent}
                                </div>

                                {/* Main Content (AppTable typically) */}
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppPageTableLayout;
